import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { SpinnerView } from 'components';
import {
  isAgency,
  isAllocator,
  isYucollectAdmin,
} from 'features/Yucollect/utils/util';
import { discoveryURL } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';
import { useAppSelector } from 'utils/hooks/useAppSelector';

type ProtectedRouteProps = {
  children: React.ReactNode; // Required children
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { userGroup: USER_GROUP = '', entityId } = useAppSelector(
    (state) => state.userConfiguration
  );

  const queryParams = new URLSearchParams(location.search);
  const paramEntityId = queryParams.get('entityId') ?? null;

  const localStorageEntityId = localStorage.getItem('tempEntityId') ?? null;

  const [verified, setVerified] = useState<boolean | null>(null); // Initialize with null

  const verifyAgencyAllocatorAssociation = async (
    agencyId: string,
    allocatorId: string
  ): Promise<boolean> => {
    try {
      const url = `${discoveryURL}/agency/allocator/verify-association?agencyId=${agencyId}&entityId=${allocatorId}`;
      const response = await HTTPClient.GetRequest(url);
      return response.status === 200 && response.data === true;
    } catch (error) {
      console.error('Verification failed:', error);
      return false;
    }
  };

  const verifyAgency = async (
    agencyId: string,
    entityId: string
  ): Promise<boolean> => {
    try {
      const url = `${discoveryURL}/agency/verify-agency?agencyId=${agencyId}&entityId=${entityId}`;
      const response = await HTTPClient.GetRequest(url);
      return response.status === 200 && response.data === true;
    } catch (error) {
      console.error('Verification failed:', error);
      return false;
    }
  };

  if (localStorageEntityId !== null) {
    return children;
  } else if (paramEntityId !== null) {
    if (isYucollectAdmin(USER_GROUP)) {
      return children;
    } else if (isAllocator(USER_GROUP)) {
      useEffect(() => {
        const verify = async () => {
          const result = await verifyAgencyAllocatorAssociation(
            paramEntityId,
            entityId ?? ''
          );
          setVerified(result);
        };
        verify();
      }, []);

      return verified === null ? (
        <SpinnerView spinning={true}>
          <div style={{ height: '90vh' }}></div>
        </SpinnerView>
      ) : verified ? (
        children
      ) : (
        <Navigate to="/" />
      );
    } else if (isAgency(USER_GROUP)) {
      useEffect(() => {
        const verify = async () => {
          const result = await verifyAgency(paramEntityId, entityId ?? '');
          setVerified(result);
        };
        verify();
      }, []);

      return verified === null ? (
        <SpinnerView spinning={true}>
          <div style={{ height: '90vh' }}></div>
        </SpinnerView>
      ) : verified ? (
        children
      ) : (
        <Navigate to="/" />
      );
    }
  }
  return <Navigate to="/" />;
};

export default ProtectedRoute;
